import React from 'react'
import { AiOutlineLeft, AiOutlineRight, AiOutlinePause } from 'react-icons/ai'
import { BiPlay } from 'react-icons/bi'
import { RiPlayListAddFill } from 'react-icons/ri'
import ReactAudioPlayer from 'react-audio-player'

import { motion } from 'framer-motion'

import PlaylistsContainer from './playlists/PlaylistsContainer'

const variants = {
    init: {
        display: 'none'
    },
    hover: {
        display: 'block'
    }
}

class Player extends React.Component {    
    state = {
        playState: false,
        duration: null,
        currentTime: null,
        interval: null,
        widthPercentage: 0,
        showList: false,
        allowPlay: false
    }


    constructor(props){
        super(props)
        this.playerRef = React.createRef();
    }


    componentDidMount(){
        this.player = this.playerRef.current.audioEl.current;
        // document.addEventListener("keydown", this.spaceFunc.bind(this), false);

    }
    UNSAFE_componentWillUpdate(nextProps, nextState){
    //   this.player.pause()
    }
    componentWillUnmount(){
        // document.removeEventListener("keydown", this.spaceFunc.bind(this), false);
        this.player.pause()

      }
    
      UNSAFE_componentWillReceiveProps(nextProps){
          if(this.props.item !== nextProps.item && nextProps.item !== null){
            this.setState({playState: true, allowPlay: false})
          }
      }

    spaceFunc(event){
        if(event.keyCode === 27) {
            this.togglePlay();
          }
    }
    togglePlay(){
        if(this.state.playState)
            this.player.pause()
        else if(this.state.allowPlay)
            this.player.play()
        this.setState({
            playState: !this.state.playState
        })
    }
    initPlayer = () => {
        this.setState({duration: this.player.duration, allowPlay: true})
        if(this.state.playState)
            this.player.play()

    }
    updateSlider = () => {
        this.state.interval = setInterval((()=>{
            this.setState({
                 currentTime: (this.player) ? parseInt(this.player.currentTime) : 0, 
                 widthPercentage: (this.player) ? this.player.currentTime / this.state.duration * 100 : 0
            });
        }), 10);
     }
     toggleListShow = () => {
        this.setState( {showList : !this.state.showList})
     }

    render(){
        const {item} = this.props;
        const modal = (
            <motion.div variants={variants} initial='init' animate='hover' className="player__playlists">
                        <PlaylistsContainer
                         setModal={this.props.setModal}
                         item={item} 
                        />
                    </motion.div>
        )

    return (
        <div className="player">
            <div className="player__info">
                <img  className="player__image" src={`${item.image}`} />
                <div className="player__text">
                    <h3>{item.name}</h3>
                    <p>{item.album}</p>
                </div>
            </div>
            <div className="player__controls">
                <button className="player__left" title="previous" onClick={this.props.playPrev}><AiOutlineLeft size="20" /></button>
                <button tabIndex="-1" className="player__start" onClick={this.togglePlay.bind(this)}>{!this.state.playState ? <BiPlay title="play" size="23" /> : <AiOutlinePause title="pause" size="23" />}</button>
                <button className="player__right" onClick={this.props.playNext} title="next" ><AiOutlineRight size="20" /></button>
            </div>
            <div className="player__loader">
                <p>00:{(this.state.currentTime) ? ((this.state.currentTime < 10) ? `0${this.state.currentTime}` : this.state.currentTime) : <>00</>}</p>

                <div className="player__lbg">
                    <div className="player__progress" style={{
                        width: `${this.state.widthPercentage}%`,
                    }}>
                        <div className="player__progress-ball">
                        </div>
                    </div>
                </div>

                <p>00:{this.state.duration ? parseInt( this.state.duration) : null}</p>

                  {
                      item.preview_url ? 
                      <ReactAudioPlayer 
                      style={{
                          display: 'none'
                      }}
                      src={`${item.preview_url}`}
                      controls
                      onPause={clearInterval(this.interval)}
                      onPlay={this.updateSlider.bind(this)}
                      onLoadedMetadata={() => this.initPlayer()}
                      autoPlay={this.state.playState}
                      onEnded={() => {if(this.state.playState){if(!this.props.playNext()){this.setState({playState: false})}}}}
                      ref={this.playerRef}
                  /> : null
                  }

            </div>
            <motion.div className="player__pl">
                <button className="player__button-pl" title="Add to a playlist" onClick={()=> this.props.setModal(modal) }><RiPlayListAddFill size="15" /></button>
            </motion.div>
        </div>
    );
        }
    
}
export default Player;
